/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-22 18:39:16
 * @LastEditors: guanbowen 
 * @LastEditTime: 2023-02-28 09:52:42
 */
const routes = [
  {
    path: '/home',
    name: 'home',
    meta: {
      title: '基本信息',
      icon: 'icon-guanyu',
      noAuth: true
    },
    component: () => import('@main/modules/home/views/home.vue')
  }
]
export default routes
